export abstract class BaseModel { }